// Angular imports
import { Injectable } from '@angular/core';

// 3rd party imports
import { DeviceDetectorService, DeviceInfo } from 'ngx-device-detector';

@Injectable({
    providedIn: 'root'
})
export class DeviceService {
    private _deviceInfo: DeviceInfo;

    constructor(private readonly deviceDetectorService: DeviceDetectorService) {}

    public get deviceInfomation(): DeviceInfo {
        if (this._deviceInfo === undefined) {
            this._deviceInfo = this.deviceDetectorService.getDeviceInfo();
        }

        return this._deviceInfo;
    }
}
